import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";
import { getDefaultState } from "./state";

const state = getDefaultState()

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
